
type CustomButtonProps = {
  name: string;
  className?: string;
  ButtonBgColor?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

const CustomButton = ({
  name,
  className,
  ButtonBgColor,
  type = "button",
  disabled = false,
}: CustomButtonProps) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`rounded-[7px] text-[13px] font-medium  px-5 py-2 text-center ${disabled ? "" : `cursor-pointer`} ${className}`}
      style={{ backgroundColor: ButtonBgColor }}
    >
      {name}
    </button>
  );
};

export default CustomButton
